import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CabTabService {
  currentStep = 0;

  STEP_IN_UZ = 0;
  STEP_IN_CRL = 1;
  STEP_IN_RU = 2;

  changeStep(stepIndex: number) {
    this.currentStep = stepIndex;
  }
}
